var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouseLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6226 15.4312C17.4201 15.4312 17.256 15.5953 17.256 15.7978C17.256 16.0003 17.4201 16.1645 17.6226 16.1645C17.8252 16.1645 17.9893 16.0003 17.9893 15.7978C17.9893 15.5953 17.8252 15.4312 17.6226 15.4312V15.4312",
    stroke: "#636B7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6227 11.3978C20.0527 11.3978 22.0227 13.3678 22.0227 15.7978C22.0227 17.6761 19.3944 21.2499 18.2005 22.7772C18.0615 22.9551 17.8484 23.059 17.6227 23.059C17.3969 23.059 17.1838 22.9551 17.0448 22.7772C15.8509 21.2509 13.2227 17.6761 13.2227 15.7978C13.2227 13.3678 15.1926 11.3978 17.6227 11.3978Z",
    stroke: "#636B7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93335 12.7992V20.8658H9.80002V14.9992C9.80002 14.1892 10.4567 13.5325 11.2667 13.5325",
    stroke: "#636B7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.3329L10.9636 1.37037C11.5363 0.797808 12.4647 0.797808 13.0374 1.37037L23 11.3329",
    stroke: "#636B7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 4.73251V3.26584H20.0667V8.39917",
    stroke: "#636B7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseLocation);
export default __webpack_public_path__ + "static/media/house-location.e6f89be2b821775d5b15a12ffc719d93.svg";
export { ForwardRef as ReactComponent };